import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

export const MaterialPage_Versions_MaterialVersions_QueryDocument = graphql(`
  query MaterialPage_Versions_MaterialVersions_Query($originalId: Id!) {
    findAllMaterialVersionsForOneOriginalId(originalId: $originalId) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id

        code
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }

        label
        title
        content
        costUsages {
          _id
          index
          costId
          quantity {
            value
            unitId
          }
        }
        statusId
        creatorId
        createdAt
        updaterId
        updatedAt
      }
    }
  }
`);

interface Props {
  readonly originalId: Id;
}

export const Versions = ({ originalId }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    MaterialPage_Versions_MaterialVersions_QueryDocument,
    { originalId },
    { enabled: !!originalId },
  );

  if (isSuccess) {
    const versions = data.findAllMaterialVersionsForOneOriginalId;

    if (versions.length) {
      return <VersionsCmp versions={versions} />;
    }

    return <NoData />;
  }

  return <Loading />;
};
